import type { FileError } from 'react-dropzone';

export const MAX_TAG_SHEET_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const TAG_SHEET_FILE_SIZE_ERROR: FileError = {
  code: 'file too large',
  message: 'File is larger than 10MB',
};

export const TAG_SHEET_ACCEPTED_FORMATS = ['.xls', '.xlsx'];

export const FETCH_LINE_ITEMS_FAILURE_MESSAGE = 'Failed to fetch line items';
export const NO_LINE_ITEMS_FOUND_MESSAGE = 'No line items found';
export const NO_LINE_ITEMS_FOUND_DESCRIPTION =
  'This campaign has no line items. Please add line items before uploading a tag sheet.';
export const LINE_ITEMS_LIMIT_EXCEEDED_MESSAGE = 'Line items limit exceeded';
export const LINE_ITEMS_LIMIT_EXCEEDED_DESCRIPTION = `More than 1000 line items per campaign is not supported.`;
export const UNMATCHED_LINE_ITEMS_MESSAGE = 'Some line items could not be matched';

export const UNSUPPORTED_VENDOR_FIELD = 'UNSUPPORTED_VENDOR';
export const UNSUPPORTED_VENDOR_MESSAGE = 'We were unable to process the tag sheet. Please create the ads manually.';
